import { IApplicationState } from '../../types/redux';

export function getFromDevelopersPropsCount(state: IApplicationState) {
  const {
    newbuilding: { fromDevelopersPropsCount },
  } = state;

  return fromDevelopersPropsCount;
}
